import React from 'react'
import { FormattedMessage } from 'react-intl'

const Dashboard: React.FC = () => {
  return (
    <div>
      <h1 className="text-text-heading text-2xl font-semibold">
        <FormattedMessage id="dashboard.heading" defaultMessage="Dashboard" />
      </h1>
      <p className="text-text-body mt-2 text-sm">
        <FormattedMessage id="dashboard.body" defaultMessage="Placeholder page for upcoming family portal features." />
      </p>
    </div>
  )
}

export default Dashboard
